import ATable, { ATableHeader } from '../../../../organisms/ATable';
import { OutboxEntry } from '../../../../../services/eventingApi';
import { formatDateTime, shortId } from '../shared/format';
import { classNames } from '../shared/ui';

const HEADER_CLASS = 'border-b px-2 text-left';
const ATTEMPTS_ALERT = 3;

const HEADERS: ATableHeader[] = [
  { id: 'service', title: 'Serviço', canSort: false, cssClass: HEADER_CLASS },
  { id: 'eventType', title: 'eventType', canSort: false, cssClass: HEADER_CLASS },
  { id: 'delivery', title: 'delivery', canSort: false, cssClass: HEADER_CLASS },
  { id: 'target', title: 'target', canSort: false, cssClass: HEADER_CLASS },
  { id: 'aggregateId', title: 'aggregateId', canSort: false, cssClass: HEADER_CLASS },
  { id: 'version', title: 'versão', canSort: false, cssClass: HEADER_CLASS },
  { id: 'occurredAt', title: 'occurredAt', canSort: false, cssClass: HEADER_CLASS },
  { id: 'attempts', title: 'Tentativas', canSort: false, cssClass: HEADER_CLASS },
];

const OutboxTable = ({ entries }: { entries: OutboxEntry[] }) => (
  <ATable headers={HEADERS}>
    {entries.map((row) => (
      <tr key={row.eventId} className="border-t border-gray-100 dark:border-gray-700 dark:text-gray-100">
        <td className="px-2 py-2 font-mono">{row.sourceService}</td>
        <td className="px-2 py-2 font-mono">{row.eventType}</td>
        <td className="px-2 py-2">{row.deliveryFormatted}</td>
        <td className="px-2 py-2">{row.target ?? '—'}</td>
        <td className="px-2 py-2 font-mono">{shortId(row.aggregateId)}</td>
        <td className="px-2 py-2">v{row.aggregateVersion}</td>
        <td className="px-2 py-2">{formatDateTime(row.occurredAt)}</td>
        <td className={classNames('px-2 py-2', { 'font-semibold text-red-600 dark:text-red-400': row.attempts >= ATTEMPTS_ALERT })}>{row.attempts}</td>
      </tr>
    ))}
  </ATable>
);

export default OutboxTable;
